import React, { useMemo, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { createElementIdFactory } from "utils/elementIds";

/**
 * DuplicateCheckCard
 *
 * Fully independent card for the duplicate-check checkbox.
 * Saves immediately on change — no blur needed for a checkbox.
 *
 * Props:
 *   checked  - initial value
 *   onSave(patch) - called with { checked_duplicate: bool }
 */
function DuplicateCheckCard({ checked: initialChecked, onSave }) {
  const createId = useMemo(() => createElementIdFactory("sale-detail-duplicate-check"), []);
  const [checked, setChecked] = useState(!!initialChecked);

  function handleChange(event) {
    const val = event.target.checked;
    setChecked(val);
    onSave({ checked_duplicate: val });
  }

  return (
    <Card id={createId("card")}>
      <Card.Header>Duplicate Check</Card.Header>
      <Card.Body>
        <Form.Group as={Row} controlId={createId("checked-duplicate") }>
          <Col>
            <Form.Check
              id={createId("checked-duplicate")}
              checked={checked}
              onChange={handleChange}
              label="Checked NOT duplicate. (See proofing procedures)"
              type="checkbox"
              name="checked_duplicate"
            />
          </Col>
        </Form.Group>
      </Card.Body>
    </Card>
  );
}

export default DuplicateCheckCard;
